import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Select2Data } from 'ng-select2-component';
import { MenuDTO } from '../models/menu-dto';
import { DistributorParams } from '../models/shared-dto';

@Injectable({
  providedIn: 'root'
})

export class SharedService {

  private pathAPI = environment.urlAPI;
  private controller = "Shared/";

  public monthData = new BehaviorSubject<Select2Data>(null);
  public yearData = new BehaviorSubject<Select2Data>(null);

  constructor(private http: HttpClient) {
    this.initializeSharedData();
  }

  public initializeSharedData() {
    const that = this;
    this.getMonthsBBDD().subscribe(resp => {
      that.setMonths(resp);
    });
    this.getYearsBBDD().subscribe(resp => {
      that.setYears(resp);
    });

  }

  debounce(func: (...args: any[]) => void, wait: number) {
    let timeout: any | undefined;

    return function executedFunction(...args: any[]) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };

      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  setMonths(data: Select2Data) {
    this.monthData.next(data);
  }

  getMonths(): Observable<Select2Data> {
    return this.monthData.asObservable();
  }

  setYears(data: Select2Data) {
    this.yearData.next(data);
  }

  getYears(): Observable<Select2Data> {
    return this.yearData.asObservable();
  }

  // public getEncrypt(data: string): Observable<any> {
  //   return this.http.get<any>(this.pathAPI + this.controller + 'GetEncrypt/' + data);
  // }

  public getRenaultFilters(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultFilters');
  }

  public getRenaultRoles(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultRoles');
  }

  public getPuntoapuntoRoles(rols: number[] = []): Observable<Select2Data> {

    return this.http.post<Select2Data>(this.pathAPI + this.controller + 'GetPuntoapuntoRoles', rols);

  }

  public getRenaultUsers(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultUsers');
  }

  public getRenaultUsersExtended(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultUsersExtended');
  }

  public getRenaultRegions(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultRegions');
  }

  public getRenaultSectorRenault(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultSectorRenault');
  }

  public getRenaultSectorDacia(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultSectorDacia');
  }

  public getRenaultVnPlate(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultVnPlate');
  }

  public getRenaultPvGroup(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultPvGroup');
  }

  public getRenaultDistributor(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultDistributor');
  }

  public getDistributorR2(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetDistributorR2');
  }

  public getRenaultDistributorContractTypes(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultDistributorContractTypes');
  }

  public getRenaultDistributorInstallationRelation(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultDistributorInstallationRelation');
  }

  public getRenaultProvinces(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultProvinces');
  }

  public getRenaultBrands(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetRenaultBrands');
  }

  public getRenaultLocalCampaignMedias(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetRenaultLocalCampaignMedias');
  }

  public getRenaultLocalCampaignTelemarketingStatus(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultLocalCampaignTelemarketingStatus');
  }

  public getRenaultCampaignCrmClientCallStatus(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultCampaignCrmClientCallStatus');
  }

  public getRenaultFichaConcesionDataType(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultFichaConcesionDataType');
  }

  public getKPIMaster(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetKPIMaster');
  }

  public getKPIMasterSection(id: number): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetKPIMasterSection/' + id);
  }

  public getKPIMasterElementSection(id: number, idSection: number | null): Observable<Select2Data> {
    let url = `${this.pathAPI}${this.controller}GetKPIMasterElementSection/${id}`;

    if (idSection !== null) {
      url += `/${idSection}`;
    }

    return this.http.get<Select2Data>(url);
  }

  public getGetRenaultZoneManager(distributorParams: DistributorParams): Observable<Select2Data> {

    let idDr = 0;
    let idSector = 0;

    if (distributorParams.Region.length > 0) {
      idDr = +distributorParams.Region[0];
    }

    if (distributorParams.Sector.length > 0) {
      idSector = +distributorParams.Sector[0];
    }

    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultZoneManager/' + idDr + '/' + idSector);
  }

  public getGetRenaultZoneManagerDistributor(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultZoneManagerDistributor');
  }

  public getGetUsersDistributor(idDistributor): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultUsersDistributor/' + idDistributor);
  }

  public getRenaultKpiSection(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultKpiSection');
  }

  public getRenaultKpiFileLoad(idSection: number): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultKpiFileLoad/' + idSection);
  }

  public getRenaultDspTeam(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultDspTeam');
  }

  public getMenu(): Observable<MenuDTO> {
    return this.http.get<MenuDTO>(this.pathAPI + this.controller + 'GetMenu');
  }
  public getYearsBBDD(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetYears');
  }
  public getMonthsBBDD(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetMonths');
  }

  public getRenaultCustomStatus(idStatus: number[]): Observable<Select2Data> {
    return this.http.post<Select2Data>(this.pathAPI + this.controller + 'GetRenaultCustomStatus', idStatus);
  }

  public getRenaultCampaignCrmByIdOrder(idOrder): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultCampaignCrmByIdOrder/' + idOrder);
  }

  public getRenaultCampaignCrmClientPreferredDealer(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetRenaultCampaignCrmClientPreferredDealer');
  }

  public GetShortUrl(url: any): Observable<string> {
    let requestOptions: Object = {
      responseType: 'string'
    }
    return this.http.post<string>(this.pathAPI + this.controller + "GetShortUrl", url, requestOptions);
  }

  public generateQrByString(url: any): Observable<any> {
    let requestOptions: Object = {
      responseType: 'string'
    }
    return this.http.post<any>(this.pathAPI + this.controller + 'GenerateQrByString', url, requestOptions);
  }

}
